import { Component, SimpleChanges, Input } from '@angular/core';
import { AppSaveService } from './app-save.service';

@Component({
  selector: 'sd-save-state-notifier',
  templateUrl: './save-state-notifier.component.html',
  styleUrls: []
})

//A pass thru *workaround* that serves to notify the save service of
//disabled state changes.  Angular does not currently have a built in
//event mechanism to subscribe to for *pristine* form changes
// (https://github.com/angular/angular/issues/10887), but the disabled state
//of the save button relies on that pristine state.  You can only access/use that
//pristine data directly in the HTML, and so we have pipes that perform logic against it.
//However that logic still only lived in the HTML, and other areas of the code
//needed to know the current disabled/enabled state of the Save button.  By passing
//the piped data in HTML to a dummy/pass through component, we can detect SimpleChanges
//and set the disabled state in a shared service.
export class SaveStateNotifierComponent {
  @Input() disableState: boolean;

  constructor(readonly appSaveService: AppSaveService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.disableState) {
      this.appSaveService.setDisabledState(changes.disableState.currentValue);
    }
  }
}
